module.exports = __webpack_public_path__ + "static/media/kunshan01.48e55e00.jpg";